export default __webpack_public_path__ + "static/media/Triton's Depths.148477ee.jpg";